//middleware
import { Route } from "react-router-dom";

//views
import { ROUTES } from "../utils/routes";
import { Degree } from "../views/Logged/Degree/Degree"; 
import { ManageDegrees } from "../views/Logged/Degree/ManageDegrees/ManageDegrees";
import { ResearchLines } from "../views/Logged/ResearchLines/ResearchLines";
import { ManageLines } from "../views/Logged/ResearchLines/ManageLines/ManageLines";
import { Commissions } from "../views/Logged/Commissions/Commissions";
import { ManageCommission } from "../views/Logged/Commissions/ManageCommission/ManageCommission";
import { Patents } from "../views/Logged/Patents/Patents";
import { ManagePatents } from "../views/Logged/Patents/ManagePatents/ManagePatents";
import { Offers } from "../views/Logged/Offers/Offers";
import { ManageOffer } from "../views/Logged/Offers/ManageOffer/ManageOffer";
import { Announcements } from "../views/Logged/Announcements/Announcements";
import { ManageAnnouncements } from "../views/Logged/Announcements/ManageAnnouncements/ManageAnnouncements";
import { Sliders } from "../views/Logged/Sliders/Sliders";
import { ManageSliders } from "../views/Logged/Sliders/ManageSliders/ManageSliders";
import { Resources } from "../views/Logged/Resources/Resources";
import { ManageResource } from "../views/Logged/Resources/ManageResources/ManageResource";
import { Users } from "../views/Logged/Users/Users";
import { ManageProfile } from "../views/Logged/ManageProfile/ManageProfile";
import { Projects } from "../views/Logged/Projects/Projects";
import { ManageProject } from "../views/Logged/Projects/ManageProjects/ManageProject";
import { Groups } from "../views/Logged/Groups/Groups";
import { ManageGroups } from "../views/Logged/Groups/ManageGroups/ManageGroups";
import { AllPublications } from "../views/Logged/Publications/AllPublications";
import { ManageResourceFolder } from "../views/Logged/Resources/ManageResources/ManageResourceFolder";
import { InvestigadoresInvitados } from "../views/Logged/InvestigadoresInvitados/InvestigadoresInvitados";
import { ManageIngestigadorInvitado } from "../views/Logged/InvestigadoresInvitados/ManageInvestigadoresInvitados/ManageInvestigadoresInvitados";
import { CoreFacilities } from "../views/Logged/CoreFacilities/CoreFacilities";
import { ManageCoreFacility } from "../views/Logged/CoreFacilities/ManageCoreFacilities/ManageCoreFacility";
import { Otros } from "../views/Logged/Otros/Otros";
import { ManageOtro } from "../views/Logged/Otros/ManageOtros.tsx/ManageOtros";
import { Intranets } from "../views/Logged/Intranets/Intranets";
import { ManageIntranet } from "../views/Logged/Intranets/ManageIntranets/ManageIntranet";
import { ManageIntranetFolder } from "../views/Logged/Intranets/ManageIntranets/ManageIntranetFolder";


const Admin = () => {
  // prettier-ignore
  return (
    <>
      <Route exact path={ROUTES.Users.all} component={Users} />
      <Route
        exact
        path={[ROUTES.Users.create, ROUTES.Users.update]}
        component={ManageProfile}
      />
      <Route exact path={ROUTES.Degree.all} component={Degree} />
      <Route
        exact
        path={[ROUTES.Degree.create, ROUTES.Degree.update]}
        component={ManageDegrees}
      />
      <Route exact path={ROUTES.Groups.all} component={Groups} />
      <Route
        exact
        path={[ROUTES.Groups.create, ROUTES.Groups.update]}
        component={ManageGroups}
      />
      <Route exact path={ROUTES.Patents.all} component={Patents} />
      <Route
        exact
        path={[ROUTES.Patents.create, ROUTES.Patents.update]}
        component={ManagePatents}
      />
      <Route exact path={ROUTES.Offers.all} component={Offers} />
      <Route
        exact
        path={[ROUTES.Offers.create, ROUTES.Offers.update]}
        component={ManageOffer}
      />
      <Route exact path={ROUTES.Announcements.all} component={Announcements} />
      <Route
        exact
        path={[ROUTES.Announcements.create, ROUTES.Announcements.update]}
        component={ManageAnnouncements}
      />
      <Route exact path={ROUTES.Sliders.all} component={Sliders} />
      <Route
        exact
        path={[ROUTES.Sliders.create, ROUTES.Sliders.update]}
        component={ManageSliders}
      />
      <Route exact path={ROUTES.Resource.all} component={Resources} />
      <Route
        exact
        path={[ROUTES.Resource.create, ROUTES.Resource.update]}
        component={ManageResource}
      />
      <Route exact path={ROUTES.Intranet.all} component={Intranets} />
      <Route
        exact
        path={[ROUTES.Intranet.create, ROUTES.Intranet.update]}
        component={ManageIntranet}
      />
      <Route exact path={ROUTES.Projects.all} component={Projects} />
      <Route
        exact
        path={[ROUTES.Projects.create, ROUTES.Projects.update]}
        component={ManageProject}
      />
      <Route exact path={ROUTES.Otros.all} component={Otros} />
      <Route
        exact
        path={[ROUTES.Otros.create, ROUTES.Otros.update]}
        component={ManageOtro}
      />
      <Route
        exact
        path={ROUTES.AllPublications.all}
        component={AllPublications}
      />
      <Route
        exact
        path={[ROUTES.RESOURCEFOLDERS.create, ROUTES.RESOURCEFOLDERS.update]}
        component={ManageResourceFolder}
      />
      <Route
        exact
        path={[ROUTES.INTRANETFOLDERS.create, ROUTES.INTRANETFOLDERS.update]}
        component={ManageIntranetFolder}
      />
      <Route
        exact
        path={ROUTES.InvestigadoresInvitados.all}
        component={InvestigadoresInvitados}
      />
      <Route
        exact
        path={[
          ROUTES.InvestigadoresInvitados.create,
          ROUTES.InvestigadoresInvitados.update,
        ]}
        component={ManageIngestigadorInvitado}
      />

      <Route
        exact
        path={ROUTES.CoreFacilities.all}
        component={CoreFacilities}
      />
      <Route
        exact
        path={[ROUTES.CoreFacilities.create, ROUTES.CoreFacilities.update]}
        component={ManageCoreFacility}
      />
    </>
  );
};

export default Admin;
